
@if(entitySelected?.group=='IASD'){
 <!-- Seccion de resumen iglesia-->
 <div class="col-xl-12 mb-3">
    <!-- abre row align-items-stretch -->
    <div class="row">
        <div class="col-xl-4">
            <div class="panel h-100">
              <div class="panel-body pb-0">
                            <div class="d-flex justify-content-between mb-1">
                                <h5><i class="fa fa-arrow-up text-success me-1"></i> Total Ingresos</h5>
                              <h5 class="d-flex justify-content-end">
                              @if(items?.revenues?.length>0){
                               $ {{items?.revenueTotals[0]?.totalValue|number:'1.0-0'}}
                               }
                           </h5>
                          </div>
                     <div class="widget-chart-info-progress align-items-center">
                        @for(i of items?.revenuesDepartaments; track i.departamentFundCode+i.itemCode){                   
                        <div class="d-flex gap-2 justify-content-between mb-2">
                            <div class="d-flex align-items-center"><i class="fa fa-circle text-success fs-8px me-2"></i>{{i?.code}} - {{capitalize(i?.departamentDisplayName)}} </div>
                            <div class="d-flex justify-content-end">
                                <div class="ps-2 fw-bold">$ {{(i?.totalValue??items?.revenueTotals?.totalValue)|number:'1.0-0'}}</div>
                            </div>
                        </div>
                        }
                  </div>

              </div>
            </div>
        </div>
        <div class="col-xl-4 mt-xl-0 mt-md-3">
            <div class="panel h-100">
              <div class="panel-body pb-0">
                <div class="d-flex justify-content-between">
                    @if(filterItemCode&&filterItemCode!=3){
                        <h5><i class="fa fa-arrow-down text-danger me-1"></i> Egresos</h5>
                    <h5 class="d-flex justify-content-end">

                           $ {{expensesItemTotal??0|number:'1.0-0'}}
                          </h5>
                    }
                    @else if(items?.expenseTotals?.length>0){
                    <h5><i class="fa fa-arrow-down text-danger me-1"></i> Total Egresos</h5>
                    <h5 class="d-flex justify-content-end">

                  $ {{items?.expenseTotals[0]?.totalValue??0|number:'1.0-0'}}
                    </h5>
                    }
                </div>
               
                <div class="widget-chart-info-progress">
                    @if(!filterItemCode||filterItemCode==3){
                        @for(i of expensesTotalsByDept; track i.departamentFundCode+i.itemCode){
                            @if(i?.departamentCode!=='-1'&&i?.totalValue>0){
                            <div class="d-flex gap-2 justify-content-between mb-2">
                                <div class="d-flex align-items-center" [ngClass]="{ 'text-danger fw-bold': i?.departamentFundCode == '-1' }"><i class="fa  text-danger fs-8px me-2" [ngClass]="{ 'fa-exclamation-circle ': i?.departamentFundCode == '-1','fa-circle text-danger fs-8px':i?.departamentFundCode != '-1' }"></i> {{i?.departamentFundCode=='-1'?'':i?.departamentFundCode+' - '}} {{capitalize(i?.displayName)}} </div>
                                <div class="d-flex justify-content-end">
                                    <div class="ps-2 fw-bold" [ngClass]="{ 'text-danger': i?.departamentFundCode == '-1' }">$ {{(i?.totalValue??items?.revenueTotals?.totalValue)|number:'1.0-0'}}</div>
                                </div>
                            </div>
                            }
                        }
                        }
                        @if(filterItemCode){
                        @for(i of items?.expensesDepartamentFunds; track i.departamentFundCode+i.code){
                            @if(i.code==filterItemCode){
                            @if(i?.departamentCode!=='-1'&&i?.totalValue>0){
                            <div class="d-flex gap-2 justify-content-between mb-2">
                                <div class="d-flex align-items-center" [ngClass]="{ 'text-danger fw-bold': i?.departamentFundCode == '-1' }"><i class="fa  text-danger fs-8px me-2" [ngClass]="{ 'fa-exclamation-circle ': i?.departamentFundCode == '-1','fa-circle text-danger fs-8px':i?.departamentFundCode != '-1' }"></i> {{i?.departamentFundCode=='-1'?'':i?.departamentFundCode+' - '}} {{capitalize(i?.displayName)}} </div>
                                <div class="d-flex justify-content-end">
                                    <div class="ps-2 fw-bold" [ngClass]="{ 'text-danger': i?.departamentFundCode == '-1' }">$ {{(i?.totalValue??items?.revenueTotals?.totalValue)|number:'1.0-0'}}</div>
                                </div>
                            </div>
                            }
                            }
                        }}
                        @if(filterItemCode&&filterItemCode!=3){
                        @if(items?.revenueTotals?.length>0 && items?.expenseTotals?.length>0){
                        <div class="d-flex gap-2 justify-content-between">
                            <div class="d-flex align-items-center"><i class="fa fa-circle text-danger fs-8px me-2"></i> Porcentaje sobre Ingresos Diezmo </div>
                            <div class="d-flex align-items-center ms-auto">
                                <div class="text-end ps-2 fw-bold">
                                    @if(items?.revenueTotals?.length>0){
                                    {{((expensesItemTotal??0) * 100 / (findTitheTotal()??0))|number:'1.2-2'}}%
                                    }
                                </div>
                            </div>
                        </div>
                        }
                        }
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-4 mt-xl-0 mt-md-3">
            <div class="panel h-100">
                 <div class="panel-body pb-0">
               <div class="d-flex justify-content-between ">
                <h5><i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos)</h5>
                   <h5 class="d-flex justify-content-end">
                    @if(items?.revenues?.length>0&&items?.expenseTotals?.length>0){
                        $ {{
                        (items?.revenueTotals[0]?.totalValue??0)
                        -(items?.expenseTotals[0]?.totalValue??0)|number:'1.0-0'}}
                        }
                   </h5>
               </div>

                    <div class="widget-chart-info-progress">
                        @for(i of items?.revenuesDepartaments; track i.departamentFundCode+i.itemCode){                   
                            <div class="d-flex gap-2 justify-content-between mb-2">
                                <div class="d-flex align-items-center"><i class="fa fa-circle text-primary fs-8px me-2"></i>{{i?.code}} - {{capitalize(i?.departamentDisplayName)}} </div>
                                <div class="d-flex justify-content-end">
                                    <div class="ps-2 fw-bold">
                                        $ 
                                        {{((i?.totalValue-(findTotalByDepartament(i?.code)?.totalValue ?? 0)))|number:'1.0-0'}}
                                    </div>
                                </div>
                            </div>
                            }
                        @if(filterItemCode&&filterItemCode!=3){
                        @if(items?.revenueTotals?.length>0){
                        <div class="d-flex gap-2 justify-content-between">
                            <div class="d-flex align-items-center"><i class="fa fa-circle text-primary fs-8px me-2"></i> Porcentaje sobre Ingresos Diezmo</div>
                            <div class="d-flex align-items-center ms-auto">
                                <div class="text-end ps-2 fw-bold">
                                    @if(items?.revenueTotals?.length>0 && items?.expenseTotals?.length>0){
                                        {{
                                        (((items?.revenueTotals[0]?.totalValue??0)
                                        -(items?.expenseTotals[0]?.totalValue??0))*100/(findTitheTotal()??0))|number:'1.2-2'}}%
                                        }
                                        @else{
                                            0%
                                        }
                                </div>
                            </div>
                        </div>
                        }
                        }
                  </div>
                </div>
              </div>
            </div>
          
      </div>
      
    <!-- Cierra row align-items-stretch -->




</div>
}


@if(entitySelected?.group!='IASD'){
    <!-- Seccion de resumen fundacion y Corporación-->
    <div class="col-xl-12 mb-3">
       <!-- abre row align-items-stretch -->
       <div class="row">
                <div class="col-xl-4">
                 <div class="panel h-100">
                   <div class="panel-body pb-0">
                                 <div class="d-flex justify-content-between mb-1">
                                   <h5 ><i class="fa fa-arrow-up text-success me-1"></i> Total Ingresos  </h5>
                                   <h5 class="d-flex justify-content-end">
                                    @if(fundCode){
                                        @if(items?.revenueTotals?.length>0&&items?.expenseTotals?.length>0){
                                         $ {{((items?.revenueTotals[0]?.totalValue))|number:'1.0-0'}}
                                        }
                                    }@else{
                                    $ {{(getTotalRevenue(items?.revenueTotals))|number:'1.0-0'}}
                                    }
                                </h5>
                               </div>
                        
                         <div class="widget-chart-info-progress align-items-center">
                            @if(selectedDepartament){
                             <div class="d-flex gap-2 justify-content-between mb-2">
                                 <div class="d-flex align-items-center"><i class="fa fa-circle text-lime fs-8px me-2"></i>{{(capitalize(findItemRevenueParent(selectedDepartament?.departamentParentCode||selectedDepartament?.parentCode)?.departamentParentName)??'Total')}} </div>
                                 <div class="d-flex justify-content-end">
                                     <div class="ps-2 fw-bold">$ {{(findItemRevenueParent(selectedDepartament?.departamentParentCode||selectedDepartament?.parentCode)?.totalValue??items?.revenueTotals?.totalValue)|number:'1.0-0'}}</div>
                                 </div>
                             </div>
                            }
                            @if(selectedDepartament){
                                <div class="d-flex gap-2 justify-content-between mb-2">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-green fs-8px me-2"></i>{{(findItemRevenueDepartament(selectedDepartament?.departamentCode)?.departamentDisplayName??'Total')}} </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="ps-2 fw-bold">$ {{(findItemRevenueDepartament(selectedDepartament?.departamentCode)?.totalValue)|number:'1.0-0'}}</div>
                                    </div>
                                </div>
                               }
                       </div>
   
                   </div>
                 </div>
               </div>
               <div class="col-xl-4 col-sm-12 mt-xl-0  mt-sm-3">
                   <div class="panel h-100">
                     <div class="panel-body pb-0">
                       <div class="d-flex justify-content-between">
                           <h5 ><i class="fa fa-arrow-down text-danger me-1"></i> Total Egresos</h5>
                           <h5 class="d-flex justify-content-end">
                            @if(fundCode){
                                $ {{(items?.expenseTotals?.length>0?items?.expenseTotals[0]?.totalValue:0)|number:'1.0-0'}}
                                }@else {
                                $ {{(getTotalExpense(items?.expenseTotals))|number:'1.0-0'}}
                                }
                            </h5>
                       </div>
                           <div class="widget-chart-info-progress">  
                            @if(selectedDepartament&&items?.expensesDepartaments?.length>0){                
                               <div class="d-flex gap-2 justify-content-between ">
                                   <div class="d-flex align-items-center"><i class="fa fa-circle text-danger fs-8px me-2"></i>Total {{capitalize(findItemExpenseParent(selectedDepartament?.departamentParentCode)?.departamentParentName)}}</div>
                                   <div class="d-flex justify-content-end">
                                       <div class="ps-2 fw-bold">$ {{findItemExpenseParent(selectedDepartament?.departamentParentCode)?.totalValue|number:'1.0-0'}}</div>
                                   </div>
                               </div>
                               }
                               @if(selectedDepartament&&items?.expensesDepartaments?.length>0){                
                                <div class="d-flex gap-2 justify-content-between ">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-pink fs-8px me-2"></i>Total {{(findItemExpenseDepartament(selectedDepartament?.departamentCode)?.departamentDisplayName)}}</div>
                                    <div class="d-flex justify-content-end">
                                        <div class="ps-2 fw-bold">$ {{findItemExpenseDepartament(selectedDepartament?.departamentCode)?.totalValue|number:'1.0-0'}}</div>
                                    </div>
                                </div>
                                }
                               @if(filter?.departamentItemCode!=3&&items?.expenses?.length>0&&items?.revenueTotals?.length>0&&filterItemCode){
                                <div class="d-flex gap-2 justify-content-between">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-danger fs-8px me-2"></i> Porcentaje sobre el ingresos {{filter?.departamentItemCode}}</div>
                                    <div class="d-flex justify-content-end">
                                        {{ ((findItemExpense(filter?.departamentItemCode)?.totalValue || 0) * 100 / (items?.revenueTotals[0]?.totalValue || 1)) | number:'1.2-2' }} %
                                    </div>
                                </div>
                                }
                         </div>
                     </div>
                   </div>
                 </div>
               <div class="col-xl-4 col-sm-12 mt-xl-0 mt-md-3 mt-sm-3">
                    <div class="panel h-100">
                         <div class="panel-body pb-0">
                       <div class="d-flex justify-content-between ">
                           <h5 > <i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos) </h5>
                           <h5 class="d-flex justify-content-end">
                            @if(fundCode){
                                @if(items?.revenueTotals?.length>0&&items?.expenseTotals?.length>0){
                                 $ {{((items?.revenueTotals[0]?.totalValue-items?.expenseTotals[0]?.totalValue))|number:'1.0-0'}}
                                }
                            }@else{
                            $ {{(getTotalRevenue(items?.revenueTotals)-getTotalExpense(items?.expenseTotals))|number:'1.0-0'}}
                            }
                        </h5>
                               
                       </div>
                            <div class="widget-chart-info-progress">

                                @if(selectedDepartament&&items?.revenuesDepartaments?.length>0&&items?.expensesDepartaments?.length>0){
                                <div class="d-flex gap-2 justify-content-between">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-purple fs-8px me-2"></i> {{capitalize(selectedDepartament?findItemExpenseParent(selectedDepartament.departamentParentCode||selectedDepartament?.parentCode)?.departamentParentName:'Total')}} </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="ps-2 fw-bold">$ {{((findItemRevenueParent(selectedDepartament?.departamentParentCode||selectedDepartament?.parentCode)?.totalValue??items?.revenueTotals?.totalValue)-(findItemExpenseParent(selectedDepartament.departamentParentCode)?.totalValue??items?.expenseTotals?.totalValue))|number:'1.0-0'}}</div>
                                    </div>
                                </div>   
                            }
                            @if(selectedDepartament&&items?.expensesDepartaments?.length>0){
                                <div class="d-flex gap-2 justify-content-between">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-indigo fs-8px me-2"></i> {{findItemExpenseDepartament(selectedDepartament.departamentCode)?.departamentDisplayName}}</div>
                                    <div class="d-flex justify-content-end">
                                        <div class="ps-2 fw-bold">$ {{((findItemRevenueDepartament(selectedDepartament?.departamentCode)?.totalValue)-(findItemExpenseDepartament(selectedDepartament.departamentCode)?.totalValue))|number:'1.0-0'}}</div>
                                    </div>
                                </div>   
                            }
                            @if(filter.departamentItemCode!=3&&items?.expenseTotals?.length>0&&items?.revenueTotals?.length>0&&filterItemCode){
                                <div class="d-flex gap-2 justify-content-between">
                                    <div class="d-flex align-items-center"><i class="fa fa-circle text-primary fs-8px me-2"></i> Porcentaje sobre el ingresos</div>
                                    <div class="d-flex justify-content-end">
                                        <div class="ps-2 fw-bold">{{((items?.revenueTotals[0]?.totalValue-items?.expenseTotals[0]?.totalValue)*100/items?.revenueTotals[0]?.totalValue)|number:'1.2-2'}} %</div>
                                    </div>
                                </div>
                            }
                          </div>    
                        
                      </div>
                    </div>
                  
               </div>
             
         </div>
         
       <!-- Cierra row align-items-stretch -->
   </div>
   }
<!-- fin bloque 1-->

